<template>
  <div
    ref="chartRef"
    style=" block-size: 500px;inline-size: 100%;"
  />
</template>

<script setup>
import * as echarts from 'echarts'
import { onMounted, onUnmounted, ref, watch } from 'vue'

const props = defineProps({
  chartData: {
    type: Array,
    required: true,
  },
  chartCategories: {
    type: Array,
    required: true,
  },
  chartColors: {
    type: Array,
    default: () => ['#4caf50', '#ffa726', '#f44336', '#607d8b', '#42a5f5'],
  },
})

const chartRef = ref(null)
const chartInstance = ref(null) // Make chartInstance a ref

const initChart = () => {
  if (chartInstance.value) {
    chartInstance.value.dispose()
  }

  const chartDom = chartRef.value
  if (chartDom) {
    chartInstance.value = echarts.init(chartDom)

    const option = {
      title: {
        text: props.chartTitle,
        left: 'center',
      },
      tooltip: {
        trigger: 'item', 
        formatter: '{b}: {c}', 
        axisPointer: { type: 'shadow' },
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '15%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: props.chartCategories,
        axisLabel: {
          interval: 0,
          rotate: 30,
        },
      },
      yAxis: {
        type: 'value',
        name: props.yAxisTitle,
      },
      series: [
        {
          data: props.chartData,
          type: 'bar',
          barWidth: '60%',
          itemStyle: {
            color: params => {
              return props.chartColors[params.dataIndex % props.chartColors.length]
            },
          },
        },
      ],
    }

    chartInstance.value.setOption(option)
    window.addEventListener('resize', chartInstance.value.resize)
  }
}

onMounted(initChart)

onUnmounted(() => {
  if (chartInstance.value) {
    window.removeEventListener('resize', chartInstance.value.resize)
    chartInstance.value.dispose()
  }
})

watch(() => [props.chartData, props.chartCategories], initChart)
</script>

<style scoped>
#chartRef {
  block-size: 500px;
  inline-size: 100%;
}
</style>
